import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { CALENDAR_ACCENT, TIME_COLUMN_WIDTH, colorWithOpacity } from "./CalendarConstants";

const OffscreenEventsIndicator = ({ count, isAbove, onTap }) => {
  if (!count) return null;

  return (
    <div
      onClick={onTap}
      style={{
        position: "absolute",
        left: TIME_COLUMN_WIDTH + 4,
        right: 4,
        ...(isAbove ? { top: 0 } : { bottom: 0 }),
        padding: "4px 10px",
        backgroundColor: colorWithOpacity(CALENDAR_ACCENT, 0.9),
        borderRadius: isAbove ? "0 0 8px 8px" : "8px 8px 0 0",
        boxShadow: `0 ${isAbove ? 2 : -2}px 4px rgba(0,0,0,0.15)`,
        display: "flex",
        alignItems: "center",
        gap: 4,
        cursor: "pointer",
        zIndex: 4,
      }}
    >
      {isAbove ? <ChevronUp size={16} color="#fff" /> : <ChevronDown size={16} color="#fff" />}
      <span style={{ color: "#fff", fontSize: 11, fontWeight: 600 }}>
        {count} {count === 1 ? "Termin" : "Termine"} {isAbove ? "weiter oben" : "weiter unten"}
      </span>
    </div>
  );
};

export default React.memo(OffscreenEventsIndicator);
